import { ExpirationData, Rollout, RolloutCacheData } from './interfaces';

/**
 * The cache to use to store the rollout data
 *
 * @type {Map<string, RolloutCacheData>}
 */
export const _cache = new Map<string, RolloutCacheData>();

export const get = (key: string): RolloutCacheData | undefined => _cache.get(key);

export const keys = (): string[] => Array.from(_cache.keys());

export const set = (name: string, rollout: Rollout) => _cache.set(name, { ...rollout, date: Date.now() });

export const setMulti = (rollouts: Rollout[]): void => rollouts.forEach((rollout) => set(rollout.name, rollout));

/**
 * The cache to use to store the rollouts that were not found on fetch (not created)
 *
 * @type {Map<string, ExpirationData>}
 */
export const _notFoundCache = new Map<string, ExpirationData>();

export const getNotFound = (key: string): ExpirationData | undefined => _notFoundCache.get(key);

export const setNotFound = (name: string) => _notFoundCache.set(name, { date: Date.now() });

export const deleteNotFound = (name: string) => _notFoundCache.delete(name);
